<div class="modal-content w-100 h-100 d-flex flex-column justify-content-between">
  <div class="d-flex flex-column">
    <apm-section-title title="{{ '445131' | apmTranslate }}"></apm-section-title>
    <span class="text bold">{{ data.unitModelName }}</span>
    <hr class="gray-divider-1" />
    <div class="list-accessories mt-2">
      <ng-container *ngFor="let accessory of data.accessories">
        <div class="mt-2 d-flex flex-row justify-content-between align-items-center">
          <span>{{ accessory.quantity }} x {{ accessory.code }} - {{ accessory | apmAccessoryName }} </span>
          <span class="text-end text-nowrap" *ngrxLet="showPrices$ as showPrices">{{
            showPrices ? (accessory.type ? accessory.type : (accessory.prices.local | apmProjectCurrency)) : '-'
          }}</span>
        </div>
      </ng-container>
    </div>
  </div>

  <apm-button class="mt-3" variant="primary" (click)="closeDialog()">{{ '444714' | apmTranslate }}</apm-button>
</div>
